import { useAppRouter } from '@/common/route/useAppRouter';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { tournamentService } from '@/services/tournament';
import { useVuelidate } from '@vuelidate/core';
import { integer, maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useTournamentLeaderboardAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        name: '',
        timeUnit: 0,
        timeDuration: null,
        publishTime: new Date(),
        unpublishTime: null
    });

    const validations = {
        name: { required },
        timeDuration: { required, integer, min: minValue(1), max: maxValue(32000) },
        publishTime: { required, value: validateDateAfter() }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            tournamentService.leaderboard.create(
                model.name,
                model.timeUnit,
                model.timeDuration,
                model.publishTime.getTime(),
                model.unpublishTime?.getTime() ?? null
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX })
    });

    return { model, v$, create };
}
